import { usePinFlow } from '../../composables/usePinFlow';
import type { PinEmits } from '../../types/pin.type';

export const usePinCreateSuccess = (emits: PinEmits) => {
  const { hidePin } = usePinFlow();

  function onContinue() {
    hidePin();
    emits('close');
  }

  return {
    onContinue,
  };
};
